module.exports = __webpack_public_path__ + "img/id-img-up.95225e67.png";